import { pickBy } from 'lodash/fp';

/** Performs 1 level deep removal of empty strings from an object, and returns the new object */
export const omitEmptyStrings = <T extends Record<string, unknown>>(
  obj: T,
): Partial<T> => pickBy<T>((x) => x !== '', obj);
